import { API2_HOST } from '../../helpers/urlHelper';
import { baseGetWithoutParam, baseGetFile } from 'services/base-services/baseService';

const baseURL = `${API2_HOST}/supplier-otif`;

const getOtifChart = async supplierId => {
  const query = supplierId ? `?supplierId=${supplierId}` : '';
  return await baseGetWithoutParam(`${baseURL}/chart${query}`);
};

const exportOtifLineItems = async (fromDate, toDate, supplierId, fileName) => {
  const params = new URLSearchParams({ fromDate, toDate });
  if (supplierId) params.append('supplierId', supplierId);
  await baseGetFile(`${baseURL}/export?${params.toString()}`, fileName);
};

export { getOtifChart, exportOtifLineItems };
